import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainLayoutComponent } from './_layout/main-layout/main-layout.component';
import { IndexComponent } from './index/index.component'; 
import { AppInitializerService } from './app-initializer.service';
import { CoreServiceService } from './core/core-service.service';
import { CompanyListComponent } from './Shared/company-list/company-list.component';
import { TableListComponent } from './Shared/table-list/table-list.component'; 
import { RatesService } from './ApiServices/rates.service'; 
import { LoaderComponent } from './Shared/loader/loader.component'; 
import { ShowHideLoaderService } from './Shared/show-hide-loader.service';
import { LiveEventsViewComponent } from './live-events-view/live-events-view.component';
import { LiveEventsService } from './Shared/live-events.service';
import { LiveEventsSendComponent } from './live-events-send/live-events-send.component';
import { ToasterService } from './Shared/toaster.service';
import { ToastrModule } from 'ngx-toastr';
import { TariffTesterComponent } from './tariff-tester/tariff-tester.component';

import { ConfirmComponent } from './Shared/confirm/confirm.component'; 
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import {ModalModule } from 'ngx-bootstrap/modal';  
import { CommonModule } from '@angular/common';  
import { SharedmodModule } from './Shared/sharedmod/sharedmod.module';
import { OccupancyComponent } from './occupancy/occupancy.component';
import { OccupancyService } from './ApiServices/occupancy.service';
import { VideostreamingComponent } from './videostreaming/videostreaming.component';
import { ParkingStationsComponent } from './parking-stations/parking-stations.component';
import { BlackListWhiteListComponent } from './black-list-white-list/black-list-white-list.component';
import { ViewRechargeRenewSlipComponent } from './view-recharge-renew-slip/view-recharge-renew-slip.component';
import { ShiftSummaryComponent } from './shift-summary/shift-summary.component';
import { FastagReconciliationComponent } from './fastag-reconciliation/fastag-reconciliation.component';
import { TchgpwdComponent } from './tchgpwd/tchgpwd.component';
import { DatePipe } from '../../node_modules/@angular/common';
import { LogFileCnvrtCSVComponent } from './log-file-cnvrt-csv/log-file-cnvrt-csv.component';
import { ParkandflyComponent } from './Parkandfly/parkandfly.component';


export function initializeApp(appInitializerService: AppInitializerService) {

  return () => appInitializerService.initializeApp();
}
@NgModule({
  declarations: [
    AppComponent,
    MainLayoutComponent,
    IndexComponent, 
    CompanyListComponent,
    TableListComponent, 
    LoaderComponent,
    LiveEventsViewComponent,
    LiveEventsSendComponent,
    TariffTesterComponent,
    ConfirmComponent,
    OccupancyComponent,
    VideostreamingComponent,
    ParkingStationsComponent,
    BlackListWhiteListComponent,
    ViewRechargeRenewSlipComponent,
    ShiftSummaryComponent,
    FastagReconciliationComponent,
    TchgpwdComponent,
    LogFileCnvrtCSVComponent,
    ParkandflyComponent
    
  ],
  imports: [
    BrowserModule, 
    CommonModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,   
    ToastrModule.forRoot({
      positionClass :'toast-bottom-right'
    }),
    ModalModule.forRoot(),
    BsDatepickerModule.forRoot(), 
    SharedmodModule
  ],
  providers: [{
    provide: APP_INITIALIZER,
    useFactory: initializeApp,
    multi: true,
    deps:[AppInitializerService, CoreServiceService] },RatesService,ShowHideLoaderService,
    LiveEventsService,
    ToasterService,
    DatePipe
    ],
  bootstrap: [AppComponent]
})
export class AppModule { }
